export const theme = {
  colors: {
    good: "#58B55D",
    scrap: "#DD2020",
    suspicious: "#EA8600",
  },
};
